import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProductSuggestionReviewFrom, Reviews } from '../Constants';

const StarRating = ({ score = 4.5, total = 5 }) => {
  const fullStars = Math.floor(score);
  const hasHalf = score % 1 >= 0.5;
  return (
    <span className="t-inline-flex t-leading-none" style={{ gap: '1px' }}>
      {Array.from({ length: total }, (_, i) => {
        const filled = i < fullStars;
        const half = !filled && hasHalf && i === fullStars;
        return (
          <span key={i} className="t-relative t-inline-block t-text-[18px]">
            <span className="t-text-g200">★</span>
            {(filled || half) && (
              <span
                className="t-absolute t-inset-0 t-overflow-hidden t-text-butter"
                style={{ width: half ? '50%' : '100%' }}
              >
                ★
              </span>
            )}
          </span>
        );
      })}
    </span>
  );
};

const ReviewsOverlay = ({ totalReviews, averageReviews, onClick, className, score = 4.5 }) => {
  const { t } = useTranslation();
  return (
    <div
      className={`t-flex t-items-center t-gap-2 t-cursor-pointer ${className}`}
      onClick={onClick && onClick}
    >
      <StarRating score={score} />
      <p className="t-m-0 t-font-sans t-text-xs sm:t-text-[13px] t-font-semibold t-text-navy/70">
        {averageReviews} {t(ProductSuggestionReviewFrom)} {totalReviews} {t(Reviews)}
      </p>
    </div>
  );
};

export default ReviewsOverlay;
